import { type Root, createRoot } from 'react-dom/client';
import RouterWrapper from './RouterWrapper';
import '../styles/tailwind.css';
import '../../static/front/assets/fonts/bonncaps/stylesheet.css';

/**
 * Enables Hot Module Reloading (HMR) for React 18
 *
 * Uses createRoot API for React 18 concurrent features.
 * The rendering of the whole app is tied to the root element.
 */

/**
 * Polyfill for getting call to work with IE11.
 */
Function.prototype.call = function (t: any, ...args: any[]) {
  return this.apply(t, args);
};

document.body.classList.remove('is-loading');

// Get the root element
const container = document.getElementById('appRoot');

if (!container) {
  throw new Error('Root element #appRoot not found');
}

// Create root once and reuse for HMR
let root: Root | null = null;

const getRoot = (): Root => {
  if (!root) {
    root = createRoot(container);
  }
  return root;
};

const renderApp = () => {
  getRoot().render(<RouterWrapper />);
};

// Initial render
renderApp();

// Hot reloading on the client (development only)
if (process.env.NODE_ENV !== 'production' && (module as any).hot) {
  (module as any).hot.accept('./RouterWrapper', () => {
    renderApp();
  });
}
